<template>
  <multi-selection-tool-button
    icon="mdi-checkbox-multiple-blank-outline"
    :disabled="disabled || (nrObjectsSelected && nrObjectsSelected > 0)"
    :tooltip="$t('ClearSelection')"
    @click="$emit('click')"
  />
</template>

<script>
import MultiSelectionToolButton from "@/components/Home/Forms/_Atoms/TableToolbarButton";

export default {
  name: "HomeFormTableSelectNoneTool",

  components: { MultiSelectionToolButton },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    nrObjectsSelected: {
      type: Number
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/TableToolbarButtons/SelectNone.vue